import type { View, ViewShare } from '../types';

export const VIEWS_SEED: ReadonlyArray<View> = [
  {
    id: 'view-luxury-africa-europe',
    name: 'Luxury – Africa & Europe',
    description: 'Luxury Collection properties across the African and European regions.',
    typeKey: 'account',
    visibility: 'organisation',
    matchMode: 'all',
    tagIds: [
      'tag-region-africa',
      'tag-region-europe',
      'tag-brand-luxury',
      'tag-survey-post-stay',
      'tag-sentiment-positive',
    ],
    ownerId: 'usr-sarah',
    createdAt: '2024-09-10',
  },
  {
    id: 'view-resorts',
    name: 'All Resorts',
    description: 'Every property classified as a resort.',
    typeKey: 'account',
    visibility: 'organisation',
    matchMode: 'any',
    tagIds: ['tag-ptype-resort', 'tag-source-google', 'tag-source-booking'],
    ownerId: 'usr-james',
    createdAt: '2024-09-12',
  },
  {
    id: 'view-corporate-mena',
    name: 'Corporate – Middle East',
    description: 'Corporate-segment properties in the Middle East region.',
    typeKey: 'account',
    visibility: 'organisation',
    matchMode: 'all',
    tagIds: ['tag-region-mena', 'tag-market-corporate'],
    ownerId: 'usr-mia',
    createdAt: '2024-10-01',
  },
  {
    id: 'view-my-flagship',
    name: 'My Flagship Portfolio',
    description: 'Personal watch-list of flagship properties.',
    typeKey: 'account',
    visibility: 'private',
    matchMode: 'any',
    tagIds: ['tag-market-flagship'],
    ownerId: 'usr-aiden',
    createdAt: '2025-02-18',
  },
  {
    id: 'view-city-shared',
    name: 'City Hotels',
    description: 'City-centre hotels, shared by the brand team.',
    typeKey: 'account',
    visibility: 'private',
    matchMode: 'any',
    tagIds: ['tag-brand-city'],
    ownerId: 'usr-james',
    createdAt: '2025-01-08',
  },
];

export const VIEW_SHARES_SEED: ReadonlyArray<ViewShare> = [
  { viewId: 'view-city-shared', userId: 'usr-aiden', canEdit: true, canShare: false },
  { viewId: 'view-city-shared', userId: 'usr-mia', canEdit: false, canShare: false },
];

export const DEFAULT_FAVORITE_VIEW_IDS: ReadonlyArray<string> = [
  'view-luxury-africa-europe',
  'view-my-flagship',
];

export const DEFAULT_FAVORITE_SCOPE_TAG_IDS: ReadonlyArray<string> = ['tag-region-africa'];
